module.exports = __webpack_public_path__ + "static/media/cpc.8fa97c3a.svg";